"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledBox = exports.StyledInputBase = exports.StyledEditableTableRow = exports.StyledTableRow = exports.DarkTableHead = exports.TableWrapper = void 0;
const material_1 = require("@mui/material");
const styles_1 = require("@mui/material/styles");
exports.TableWrapper = (0, styles_1.styled)("div")({
    backgroundColor: "white",
    borderRadius: "4px",
    overflow: "hidden"
});
exports.DarkTableHead = (0, styles_1.styled)(material_1.TableHead)(() => ({
    backgroundColor: "#425563",
    "th": {
        color: "#fff",
        fontWeight: "bold",
        lineHeight: "1rem",
        minWidth: "85px",
        textTransform: "uppercase",
    }
}));
exports.StyledTableRow = (0, styles_1.styled)(material_1.TableRow)({
    "&:nth-of-type(even)": {
        backgroundColor: "#f7f7f7",
    },
    "&:last-child td, &:last-child th": {
        border: 0,
    },
    ":hover": {
        backgroundColor: "#EEF3F6",
    },
    "td": {
        height: "54px",
        padding: "12px 16px",
    },
    "&:not(:hover) .MuiStack-root": {
        display: "none",
    },
});
exports.StyledEditableTableRow = (0, styles_1.styled)(exports.StyledTableRow)({
    backgroundColor: "#EEF3F6",
});
exports.StyledInputBase = (0, styles_1.styled)(material_1.InputBase)(({ theme }) => ({
    "& .MuiInputBase-input.MuiSelect-select": {
        minHeight: "36px",
        minWidth: "60px",
        borderRadius: "6px",
        backgroundColor: theme.palette.background.paper,
        border: "1px solid #ced4da",
        ".MuiMenuItem-root": {
            padding: "10px 16px",
        }
    },
}));
exports.StyledBox = (0, styles_1.styled)(material_1.Box)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#fff",
    boxShadow: "0px 16px 32px rgba(51, 51, 51, 0.1);",
    width: 426,
    borderRadius: "8px",
    padding: "32px"
});
